export default function betAmountOptions(goldPriceInUsd) {
  if (!goldPriceInUsd) {
    return []
  }

  return [
    goldPriceInUsd * 1,
    goldPriceInUsd * 10,
    goldPriceInUsd * 100,
    goldPriceInUsd * 1000,
  ]
}
